import { IProductListState } from "../ItemsContainer";
import { SET_CATEGORY_ID,SET_MENUS_LIST, SET_FILTER_STATE, SET_PRODUCT_LIST, SET_SELECTED_PRODUCT_LIST, SET_SELECTED_SUBCATS, SET_SUBCATEGORY_ID,SET_ITEMS_NOT_IN_MENU } from "./itemContainer.actions";

export const productListInitalState: IProductListState = {
    productList: [],
    selectedProductList: [],
    categoryID: "",
    subcategoryID: "",
    selectedSubCategories: [],
    itemsNotInMenu:[],
    menus:[],
    filterState: []
};

export function productListReducer(state: IProductListState, action: { type: string, payload: any; }) {
    switch (action.type) {
        case SET_CATEGORY_ID:
            return {
                ...state,
                categoryID: action.payload
            };
        case SET_SUBCATEGORY_ID:
            return {
                ...state,
                subcategoryID: action.payload
            };
        case SET_SELECTED_SUBCATS:
            return {
                ...state,
                selectedSubCategories: action.payload
            };
        case SET_SELECTED_PRODUCT_LIST:
            return {
                ...state,
                selectedProductList: action.payload
            };
        case SET_PRODUCT_LIST:
            return {
                ...state,
                productList: action.payload
            };
            case SET_FILTER_STATE:
                return {
                    ...state,
                    filterState: action.payload
                };
                case SET_ITEMS_NOT_IN_MENU:
                    return {
                        ...state,
                        itemsNotInMenu: action.payload
                    };
                    case SET_MENUS_LIST:
                        return {
                            ...state,
                            menus: action.payload
                        };

                    
        default:
            return state;
    }
}